import { ClassNameProvider } from '@/styles/CoverBox';
import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import React, { ReactNode } from 'react';
import { CoverBox } from './CoverBox';

export interface StandaloneCoverBoxProps extends StandaloneComponentProps<typeof CoverBox> {
  headline: string;
  bodyText: string;
  expandCopy?: ReactNode;
  icon?: ReactNode;
  images?: JSX.Element[];
}

export const StandaloneCoverBox: StandaloneComponent<StandaloneCoverBoxProps> = ({
  headline,
  bodyText,
  expandCopy,
  icon,
  images,
  options,
  ...props
}) => {
  const { $headline, $body, $group, $icon, $images, $expand, ...$base } = options ?? {};

  return (
    <ClassNameProvider value={{ ...$base, size: $base.size ?? $base.variant }}>
      <CoverBox {...$base} {...props}>
        {icon && <CoverBox.Icon {...$icon}>{icon}</CoverBox.Icon>}

        <CoverBox.Group {...$group}>
          <CoverBox.Headline {...$headline}>{headline}</CoverBox.Headline>

          <CoverBox.Body
            expand={<CoverBox.Expand {...$expand}>{expandCopy ?? <>&nbsp;...Läs mer</>}</CoverBox.Expand>}
            markup={bodyText}
            {...$body}
          >
            {images && images.length > 0 && (
              <CoverBox.Images {...$images}>
                {images.map((image, index) => React.cloneElement(image, { key: index }))}
              </CoverBox.Images>
            )}
          </CoverBox.Body>
        </CoverBox.Group>
      </CoverBox>
    </ClassNameProvider>
  );
};

export default StandaloneCoverBox;
